// ##############################
// // // LoginCard styles
// #############################

import {
  card,
  cardHeader,
  defaultFont,
  primaryCardHeader,
  redCardHeader,
  yellowCardHeader,
  purpleCardHeader,
  pinkCardHeader,
} from 'assets/styles/jss/main';

const loginCardStyle = {
  card: {
    ...card,
    width: '100vw',
    minHeight: 'calc(100vh - 80px)',
    transform: 'translate3d(0, -5px, 0)',
    padding: '20px',
    transition: 'all 300ms linear',
    '@media screen and (min-width:600px)': {
      width: 384,
      maxWidth: '90vw',
      minHeight: 'auto',
      transform: 'translate3d(0, 0, 0)',
    },
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none',
  },
  cardHeader: {
    ...cardHeader,
    ...defaultFont,
    textAlign: 'center',
    padding: '0',
    marginBottom: '20px',
  },
  cardPlainHeader: {
    marginLeft: 0,
    marginRight: 0,
  },
  primaryCardHeader,
  redCardHeader,
  yellowCardHeader,
  purpleCardHeader,
  pinkCardHeader,
  cardTitle: {
    ...defaultFont,
    margin: '13px 0 25px',
    fontWeight: '400',
    fontSize: '1.3em',
    textTransform: 'uppercase',
  },
  cardSubtitle: {
    ...defaultFont,
    textAlign: 'center',
    fontSize: '14px',
  },
  cardActions: {
    padding: '0',
    display: 'block',
    height: 'auto',
  },
  cardContent: {
    position: 'relative',
    padding: '0',
    fontSize: '16px',
  },
  cardFooter: {
    fontSize: '16px',
  },
  inputAdornmentIcon: {
    color: '#555',
  },
  left: {
    textAlign: 'left',
  },
  right: {
    textAlign: 'right',
  },
  center: {
    textAlign: 'center',
  },
  root: {
    overflow: 'initial',
  },
};

export default loginCardStyle;
